import { App } from '@grafikr/components';

const visualDiscounts = ({ emitter }: App) => {
  const init = async () => {
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return undefined;
    };

    const discountCode = getCookie('discount_code');
    if (!discountCode) {
      return;
    }

    const response = await fetch(
      `${window.location.origin}/cart?view=discounts&code=${discountCode}`,
    );
    const responseText = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(responseText, 'text/html');
    const discountElement = doc.querySelector('[data-discount]');
    if (!discountElement) {
      return;
    }

    const discount = JSON.parse(discountElement.textContent);

    sessionStorage.setItem('discount', JSON.stringify(discount));
    emitter.emit('discount:added');
  };

  init();
};

export default visualDiscounts;
